// material-ui
import {
    Box,
    Button,
    Grid,
    Paper,
    TextField,
    Typography,
    useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForgetPasswordMutation } from "../../store/slices/apiSlice";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
// import logo from "../../assets/images/logo/bitmap@2x.jpg";
import logo from "../../assets/images/logo/sga-takeda.png";
import virLogo from "../../assets/images/logo/vir-logo.jpg";
import vector from "../../assets/images/login/undrawMedicineB1Ol@3x.png";
import CustomButton from "../../components/@extended/CustomButton";
import * as Yup from "yup";
import { EMAIL_REGEX, EMAIL_VALIDATION_MESSAGE, extractErrorMessage } from "../../util/util";
import pfas from "../../assets/images/login/pFas.png";
import earth from "../../assets/images/login/earth-removebg-preview.png";
import esg from "../../assets/images/login/esg-removebg-preview.png";
import mevoice from "../../assets/images/login/ME-VOICE_Logo.png";
import { useFormik } from "formik";
import ShowMessage from "../../components/showMessage/ShowMessage";
import { useResponsive } from "../../hooks/ResponsiveProvider";
import { useDispatch } from "react-redux";
import { openMessage } from "../../store/slices/showMessageSlice";

import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';

const Reset=()=>{
    const [forgot, { error }] = useForgetPasswordMutation();
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isMediumScreen } = useResponsive();

    const docSchema = Yup.object().shape({
      email: Yup.string().required("Username/Email Id is required")
      .matches(EMAIL_REGEX, EMAIL_VALIDATION_MESSAGE),
    });

    const formik = useFormik({
        initialValues: {
          email: "",
        },
        validationSchema: docSchema,
        onSubmit: async (values) => {
          try {
            const result = await forgot({
              email: values.email,
            });
            if (!result?.error) {
              openMessageNotification({
                message: "Password reset email sent successfully. Please check your inbox for the temporary password.",
                type: "success",
              });
              navigate("/login");
            } else {
              // Extract user-friendly error message
              const errorMessage = extractErrorMessage(result.error, {
                defaultMessage: "Failed to send password reset email. Please try again.",
                customMessages: {
                  USER_NOT_FOUND: "User not found. Please check your email address and try again.",
                  SERVER_ERROR: "Unable to process password reset request. Please try again later.",
                }
              });
              openMessageNotification({
                message: errorMessage,
                type: "error",
              });
            }
          } catch (error) {
            // Handle unexpected errors
            const errorMessage = extractErrorMessage(error, {
              defaultMessage: "An unexpected error occurred. Please try again.",
            });
            openMessageNotification({
              message: errorMessage,
              type: "error",
            });
          }
        },
      });

      const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevents the default form submission behavior
        formik.handleSubmit();
      };
    
      const openMessageNotification = (message) => {
        dispatch(openMessage({ message: message.message, messageSeverity: message.type }))
      };
    
    return (
      <>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4, paddingTop: isMediumScreen ? 8 : 4 }}>
          <Typography variant="h6" color="initial">
            Forgot Password
          </Typography>
        </Box>
        <form onSubmit={handleFormSubmit}>
          <Grid container rowSpacing={3}>
            <Grid item xs={12} px={3}>
              <Typography variant="body1" color="#5d5d5d" pb={1}>
                Username/Email Id
              </Typography>
              <TextField
                name="email"
                fullWidth
                placeholder="Username/Email Id"
                onChange={formik.handleChange}
                value={formik.values.email}
                onBlur={formik.handleBlur}
                helperText={formik.touched.email && formik.errors.email}
                error={formik.touched.email && Boolean(formik.errors.email)}
              />
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', px: 3 }}>
              <Button
                variant="text"
                sx={{ width: 'fit-content', color: theme.palette.primary.light, p: 0, ':hover': 'none' }}
                size="large"
                onClick={() => {
                  navigate('/login');
                }}
              >
                Back to Login
              </Button>

              <CustomButton
                size="large"
                type="submit"
                sx={{
                  width: 150,
                  backgroundColor: theme.palette.primary.light,
                }}
              >
                Submit
              </CustomButton>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', px: 3, py: 5 }}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <img src={virLogo} alt="Bloqcube" width="100" />
              </Box>
            </Grid>
          </Grid>
        </form>
      </>
    );
}

const ForgotPassword = () => {
  
  const theme = useTheme();
  const { isMediumScreen } = useResponsive();
  
  // const openMessageNotification = (message) => {
  //   dispatch(openMessage({ message: message.message, messageSeverity: message.type }))
  // };

  return (
    <>
      <Grid container sx={{ height: "100vh", width: '100%' }}>
          <Box sx={{ p: 4, position:'absolute', right:0, display: "flex", justifyContent: isMediumScreen ? "center" : 'flex-end', position:'absolute' , right:0 }}>
            <Button
              size="large"
              variant="outlined"
              sx={{ textTransform: "none", color: theme.palette.primary.light }}
              startIcon={
                <HelpOutlineOutlinedIcon
                  sx={{ color: theme.palette.primary.light }}
                />
              }
            >
              Help & Support
            </Button>
          </Box>
        <Grid
          item
          md={6}
          //sm={12}
          style={{
            display: "flex",alignItems:'center', justifyContent: isMediumScreen ? 'center' : "flex-end", ...(isMediumScreen && {
              alignItems: 'center',
            })
          }}
        >
          <Paper sx={{
            height: isMediumScreen ? 'auto' : 550, ...(!isMediumScreen && {
              width: 480,
            })
            }} elevation={isMediumScreen?0:5}>

            <Box sx={{ display: "flex", justifyContent: "center", pt: 5 }}>
              <img src={logo} alt="Bloqcube" width="250" />
            </Box>

            <Reset/>

          </Paper>
        </Grid>
        {!isMediumScreen && <Grid
          item
          md={6}
          style={{ display: "flex", alignItems:'center' }}
        >
          <Swiper
              style={{height: 480, width: 480, marginLeft: 25}}
            >
               <SwiperSlide>
                <img src={mevoice} alt="Bloqcube" width="100%" height={'100%'} style={{ borderRadius: 10 }} />
              </SwiperSlide>
              {/* <SwiperSlide style={{display:'flex', alignItems:'center',justifyContent:'flex-end'}}>
                <img src={vector} alt="Bloqcube" width="95%"/>
              </SwiperSlide>
              <SwiperSlide>
                <img src={pfas} alt="Bloqcube" width="100%" height={'100%'} style={{borderRadius:10}}/>
              </SwiperSlide>
              <SwiperSlide>
                <img src={earth} alt="Bloqcube" width="100%" height={'100%'} style={{borderRadius:10}}/>
              </SwiperSlide>
              <SwiperSlide>
                <img src={esg} alt="Bloqcube" width="100%" height={'100%'} style={{borderRadius:10}}/>
              </SwiperSlide> */}
            </Swiper>
        </Grid>}
      </Grid>
      <ShowMessage />
    </>
  );
};
  
export default ForgotPassword;
  